import { bridge } from '../../bridge';
import { useCallback } from 'react';
import { useRootStackNavigation } from '../../../hooks/useRootNavigation';

/**
 * - 최근본상품페이지로 이동
 */
export const useMoveToRecentlyViewedGoods = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const navigation: any = useRootStackNavigation();

  const moveToRecentlyViewedGoods = useCallback(() => {
    bridge.openDeeplink(
      `ably://react/App?package=goods&screen=RecentlyViewedGoods`,
      {
        webCallback: () => {
          navigation.navigate('RecentlyViewedGoods');
        },
      },
    );
  }, [navigation]);
  return {
    moveToRecentlyViewedGoods,
  };
};
